<template>
    <div id="app">
        <top-navbar />
        <router-view />
        <footer-bar />
    </div>
</template>

<script>
import FooterBar from '@/components/footer-bar'
import TopNavbar from '@/components/top-navbar'
import { mapMutations } from 'vuex'

export default {
    components: {
        FooterBar,
        TopNavbar,
    },
    methods: {
        ...mapMutations(['setOnline', 'setOffline']),
        updateOnline () {
            if (typeof window.navigator.onLine === 'undefined') {
                this.setOnline()
                return
            }

            if (window.navigator.onLine) {
                this.setOnline()
            } else {
                this.setOffline()
            }
        }
    },
    created () {
        window.addEventListener('online', this.setOnline)
        window.addEventListener('offline', this.setOffline)
        this.updateOnline()
    },
    destroyed () {
        window.removeEventListener('online', this.setOnline)
        window.removeEventListener('offline', this.setOffline)
    },
}
</script>

<style lang="scss">

</style>
